import 'src/global.css';

// ----------------------------------------------------------------------

import { Toaster } from 'react-hot-toast';

import { Router } from 'src/routes/router';

import { useScrollToTop } from 'src/hooks/use-scroll-to-top';
import { DebugModeProvider } from 'src/hooks/use-debug-mode';

import { ThemeProvider } from 'src/theme/theme-provider';

import { MotionLazy } from 'src/components/animate/motion-lazy';
import { ProgressBar } from 'src/components/progress-bar';
import { defaultSettings, SettingsDrawer, SettingsProvider } from 'src/components/settings';

import { AuthProvider } from './auth/AuthContext';

import { GqlProvider } from './GqlProvider';
import DialogTwoFactorRecoveryCodeDownload from './components/dialogs/dialog-2fa-download-recovery-code';

// ----------------------------------------------------------------------

export default function App() {
  useScrollToTop();

  return (
    <AuthProvider>
      <SettingsProvider settings={defaultSettings}>
        <ThemeProvider>
          <GqlProvider>
            <DebugModeProvider>
              <MotionLazy>
                <ProgressBar />
                <SettingsDrawer />
                <Router />
                <DialogTwoFactorRecoveryCodeDownload />
                <Toaster />
              </MotionLazy>
            </DebugModeProvider>
          </GqlProvider>
        </ThemeProvider>
      </SettingsProvider>
    </AuthProvider>
  );
}
